import { DAILY_WORDS, VALID_GUESSES } from "../constants/wordlist";

export const isWordInWordList = (word: string) => {
  return VALID_GUESSES.includes(word.toLowerCase());
};

export const isWinningWord = (word: string) => {
  return solution === word;
};

export const getWordOfDay = () => {
  // February 12, 2026 Game Epoch (Jimdle launch day)
  const epochMs = new Date("2026-02-12T00:00:00").getTime();
  const now = Date.now();
  const msInDay = 86400000;
  const index = Math.floor((now - epochMs) / msInDay);

  // Cycle through daily words
  return DAILY_WORDS[index % DAILY_WORDS.length].toUpperCase();
};

export const solution = getWordOfDay();
